import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import ChapterList from '../../../Chapter/ChapterList'
import TabListSection from '../TabListSection'
const PANEL_KEY = 'chapters'

const ChaptersPanel = ({ eventKey }) => {

  const chapters = useSelector(state => state.asset.productDetails.chapters)

  return(
    <TabListSection
      condition={eventKey === PANEL_KEY}
      eventKey={PANEL_KEY}
    >
      <ChapterList chapters={chapters} />
    </TabListSection>
  )
}

export default ChaptersPanel

ChaptersPanel.propTypes = {
  eventKey: PropTypes.string.isRequired
}
